module.exports = {
  // Function to get the url of the profile photo
  getUserPhoto(uid, size = '') {
    return `https://firebasestorage.googleapis.com/v0/b/sharo-a1770.appspot.com/o/User%2F${uid}%2FProfile%2F${
      size == '' ? 'photo' : `thumb@${size}_photo`
    }?alt=media`
  }
}
